/* Authentification */
export const AUTH_USER = "AUTH_USER"
export const LOGOUT_USER = "LOGOUT_USER"

export const GET_USERS = "GET_USERS"
export const CREATE_USER = "CREATE_USER"
